import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import Copyright from './copyright';

const enhance = compose(
  withNamespaces(['common']),
);
export default enhance(Copyright);
